import { HeadingDescSmall } from '../../Headings';
import './simpleTag.css';

function SimpleTag(props) {
  const { text, children } = props;
  return (
    <div className="simpleTag">
      {children}
      <HeadingDescSmall text={text} />
    </div>
  );
}

export default SimpleTag;
